import { useMutation } from "react-query";
import {
	login_api,
	forgotPasssword_api,
	verifyResetToken_api,
	updatePassword_api,
	deleteUser_api,
} from "../services/auth";

export const useLogin = () => useMutation("login", (body) => login_api(body));

export const useForgotPassword = () =>
	useMutation("forgotPasssword", (body) => forgotPasssword_api(body));

export const useVerifyResetToken = () =>
	useMutation("verifyResetToken", (body) => verifyResetToken_api(body));

export const useUpdatePassword = () =>
	useMutation("updatePassword", (body) => updatePassword_api(body));

export const useDeleteUser = () =>
	useMutation("deleteUser", (id) => deleteUser_api(id));
